import { createFileRoute } from "@tanstack/react-router";
import { seoHead } from "@/lib/seo/head";
import AdminGeckoCheck from "@/pages/AdminGeckoCheck";
import AdminGate from "@/components/AdminGate";

export const Route = createFileRoute("/admin/geckocheck")({
  head: () => seoHead("/admin/geckocheck"),
  component: () => (
    <AdminGate><AdminGeckoCheck /></AdminGate>
  ),
});
